export default __webpack_public_path__ + "static/media/O-101.be06203c.png";